<template>
	<router-view></router-view>
</template>

<script>
	export default {
		data(){
			return{
			}
		},
		components:{
		},
		mounted:function(){

		},
		methods:{

		}
	}
</script>

<style lang="less">
</style>



// WEBPACK FOOTER //
// src/App.vue